import { Type } from 'typebox';
import { DailyReportEntry, DailyReportEntryTypes } from './daily-report-entry.js';
export const MedicationNoteEntry = Type.Evaluate(Type.Intersect([
    DailyReportEntry,
    Type.Object({
        typeName: Type.Literal(DailyReportEntryTypes.medicationNote),
        noteType: Type.Optional(Type.String()),
        question: Type.Optional(Type.String()),
        questionId: Type.Optional(Type.String({ minLength: 1 })),
        answer: Type.Optional(Type.String()),
        answerType: Type.Optional(Type.String())
    })
]));
